/**
 * Password show/hide toggle.
 *
 * Progressive enhancement: the button is rendered by snippets/password-toggle.liquid
 * and only becomes useful once this script runs. Without JS the field stays masked.
 */
(function () {
  var SELECTOR = '[data-password-toggle]';

  function inputFor(button) {
    return document.getElementById(button.getAttribute('aria-controls'));
  }

  function setState(button, input, reveal) {
    var start = input.selectionStart;
    var end = input.selectionEnd;

    input.type = reveal ? 'text' : 'password';
    button.setAttribute('aria-pressed', reveal ? 'true' : 'false');
    button.setAttribute('aria-label', reveal ? button.dataset.labelHide : button.dataset.labelShow);

    // Changing the type resets the caret in some browsers, which is disorienting
    // when toggling mid-typing.
    if (start !== null && typeof input.setSelectionRange === 'function') {
      try {
        input.setSelectionRange(start, end);
      } catch (error) {
        // Not all input types support selection ranges; nothing to restore.
      }
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest(SELECTOR) : null;
    if (!button) return;

    var input = inputFor(button);
    if (!input) return;

    event.preventDefault();
    setState(button, input, input.type === 'password');
    input.focus();
  });

  // Re-mask before the form is submitted.
  //
  // Shopify's storefront captcha script saves a copy of the form into
  // sessionStorage so it can repopulate the fields after a challenge, and it
  // decides what to skip by looking for `input[type="password"]`. A field left
  // in its revealed state is no longer matched by that check, so the password
  // would be written out in plain text. Capture phase so this runs before that
  // listener on `document`.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.querySelectorAll !== 'function') return;

      Array.prototype.forEach.call(form.querySelectorAll(SELECTOR), function (button) {
        var input = inputFor(button);
        if (input && input.type === 'text') setState(button, input, false);
      });
    },
    true
  );
})();
